import { styled } from 'twin.macro';

const TableBody = styled.tbody``;

export default TableBody;
